function loadMoreProducts() {
  // Get fresh references each time the function is called
  var load_more_btn = $('.load-more_btn');
  var load_more_spinner = $('.load-more_spinner');
  var product_grid = $('#product-grid');
  
  var next_url = product_grid.data('next-url');
  
  // Check if we need to preserve sorting parameters
  var current_sort = new URLSearchParams(window.location.search).get('sort_by');
  
  if (next_url) {
    // Add or update the sort parameter if needed
    if (current_sort) {
      // Create a URL object to easily modify parameters
      var next_url_obj = new URL(next_url, window.location.origin);
      var next_params = next_url_obj.searchParams;
      
      // Update or add the sort parameter
      next_params.set('sort_by', current_sort);
      
      // Get the modified URL
      next_url = next_url_obj.toString();
    }
  } else {
    console.error("No next URL available");
    load_more_spinner.hide();
    return;
  }
  
  $.ajax({
    url: next_url,
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      load_more_btn.hide();
      load_more_spinner.show();
    }
  }).done(function(response) {
    // Hide the spinner
    load_more_spinner.hide();
    
    // Parse the response into a jQuery object
    var $response = $(response);
    
    // Find the product grid in the response
    var new_product_grid = $response.find('#product-grid');
    
    // If we found a product grid in the response
    if (new_product_grid.length > 0) {
      // Get any new product cards - use the correct selector
      var new_products = new_product_grid.find('product-card');
      
      // Check if we have new products to add
      if (new_products.length > 0) {
        
        // Filter out duplicate products by product URL/handle
        var existing_urls = [];
        product_grid.find('product-card h3 a').each(function() {
          existing_urls.push($(this).attr('href'));
        });
        
        var unique_products = [];
        new_products.each(function() {
          var product_url = $(this).find('h3 a').attr('href');
          if (!existing_urls.includes(product_url)) {
            unique_products.push($(this));
          }
        });
        
        // Add only unique products
        if (unique_products.length > 0) {
          $.each(unique_products, function(i, product) {
            product_grid.append(product);
          });
        } else {
          console.log("All products were duplicates");
        }
        
        // Get the next URL from the response
        var new_next_url = new_product_grid.data('next-url');
        
        // Update the next URL on our current grid
        if (new_next_url) {
          // Maintain the sorting in the stored next-url
          if (current_sort) {
            var new_next_url_obj = new URL(new_next_url, window.location.origin);
            new_next_url_obj.searchParams.set('sort_by', current_sort);
            new_next_url = new_next_url_obj.toString();
          }
          
          product_grid.data('next-url', new_next_url);
          load_more_btn.show();
        } else {
          // No more pages
          console.log("No more pages available");
        }
      } else {
        console.log("No new products found in response");
      }
    } else {
      console.error("Could not find product grid in response");
    }
  }).fail(function(jqXHR, textStatus, errorThrown) {
    console.error("Failed to load more products:", textStatus, errorThrown);
    load_more_spinner.hide();
    load_more_btn.show(); // Show the button again on error
  });
}

// For the document ready handler
$(document).ready(function() {
  // Get fresh reference to the button
  var load_more_btn = $('.load-more_btn');
  
  // Show the button if we have a next URL
  if ($('#product-grid').data('next-url')) {
    load_more_btn.show();
  }
  
  // Use event delegation for the click handler
  $(document).on('click', '.load-more_btn', function(e) {
    e.preventDefault();
    loadMoreProducts();
  });
});